import * as types from '../mutation-types';

const state = () => ({
	notificationTemplates: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/notification-templates').then(response => {
			commit(types.STORE_NOTIFICATION_TEMPLATES, response.data);
		});
	},

	update({commit}, {notificationTemplates}) {
		return axios.put('/api/notification-templates', {notificationTemplates}).then(response => {
			commit(types.STORE_NOTIFICATION_TEMPLATES, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_NOTIFICATION_TEMPLATES](state, notificationTemplates) {
		state.notificationTemplates = notificationTemplates;
	},
};

const getters = {
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};